@if (title) {
<div class="-menu-navigator">
  <app-link class="-title" (click)="closeMenu()">
    <span class="-icon-container"><icon icon="l_left_ankle"></icon></span>{{title}}</app-link>
</div>
}
<div class="-menu-category">
    @for (category of products; track category) {
      <div class="-default-category-menus">
        <div class="-default-category-menu">
          <h2>{{ category.subtitle }}</h2>
        </div>
        <div class="-menu-items-container">
            @for (item of category.children; track item) {
              <app-link [to]="item.path">
                <menu-item-card [name]="item.title" [description]="item.description" [icon]="item.icon"></menu-item-card>
              </app-link>
            }
        </div>
      </div>
    }
</div>
